import { useState, useEffect } from 'react';

export function useDirection() {
  const [direction, setDirection] = useState('ltr');
  
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Get initial direction
      setDirection(document.documentElement.dir || 'ltr');
      
      // Set up a mutation observer to watch for changes to dir attribute
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'dir') {
            setDirection(document.documentElement.dir || 'ltr');
          }
        });
      });
      
      observer.observe(document.documentElement, { attributes: true });
      
      return () => observer.disconnect();
    }
  }, []);
  
  return direction;
}
